import React, { useEffect, useState } from 'react';

import client from '../api/client';
import Spinner from '../components/ui/Spinner';

// GET /api/privacy-policy returns a full HTML document (server-authored,
// trusted content) — parse out just the <body> so it can sit inside our
// own page chrome instead of nesting a second <html>/<head>/<body>.
export default function PrivacyPolicy() {
  const [html, setHtml] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let active = true;
    client
      .get('/privacy-policy')
      .then(({ data }) => {
        if (!active) return;
        const body = new DOMParser().parseFromString(data, 'text/html').body;
        setHtml(body.innerHTML);
      })
      .catch(() => {
        if (active) setError(true);
      });
    return () => {
      active = false;
    };
  }, []);

  if (error) {
    return (
      <div className="ss-container ss-state">
        <h2>Couldn't load the privacy policy</h2>
        <p style={{ marginTop: 'var(--ss-space-4)' }}>Please try again later.</p>
      </div>
    );
  }

  if (html === null) {
    return <div className="ss-container ss-state"><Spinner label="Loading privacy policy" size={32} /></div>;
  }

  return (
    <section
      className="ss-container ss-static-page"
      style={{ paddingBlock: 'var(--ss-space-6)' }}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
